import type { AppointmentStatus, PaymentStatus } from "@prisma/client";

const appointmentStatusEs: Record<AppointmentStatus, string> = {
  PENDING: "Pendiente",
  CONFIRMED: "Confirmado",
  CANCELLED: "Cancelado",
  COMPLETED: "Completado",
  NO_SHOW: "No asistió",
};

const paymentStatusEs: Record<PaymentStatus, string> = {
  UNPAID: "Sin pagar",
  DEPOSIT_PAID: "Seña pagada",
  PARTIAL_PAID: "Pago parcial",
  PAID: "Pagado",
  REFUNDED: "Reembolsado",
};

export function labelAppointmentStatus(s: AppointmentStatus) {
  return appointmentStatusEs[s] ?? s;
}

export function labelPaymentStatus(s: PaymentStatus) {
  return paymentStatusEs[s] ?? s;
}
